
import React, { useState, useEffect } from "react";
import ConversionGauge from "./admindashboardutils/components/ConversionGauge";
import ConversionBarChart from "./admindashboardutils/components/ConversionBarChart";
import CallStatisticsPie from "./admindashboardutils/components/CallStatisticsPie";
import AverageCallTime from "./admindashboardutils/components/AverageCallTime";
import QueueList from "./admindashboardutils/components/QueueList";
import { fetchCallHistory, fetchQueueData, fetchPositiveCallData } from "./admindashboardutils/utils/fetchUtils";
import { calculateConversionPercentage } from "./admindashboardutils/utils/fetchUtils";
const Dashrigmo = ({ user }) => {
  const [callData, setCallData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [positiveCallData, setPositiveCallData] = useState([]);
  const [error, setError] = useState(null);
  const [queueData, setQueueData] = useState([]);
  const [pieData, setPieData] = useState([
    { name: "Disconnected Calls", value: 0, color: "#DC143C" },
    { name: "DNC Calls", value: 0, color: "#FFA500" },
    { name: "Positive Calls", value: 0, color: "#9ACD32" },
    { name: "Negative Calls", value: 0, color: "#FF69B4" },
  ]);
  const [averageCallTime, setAverageCallTime] = useState(0);
  const [conversionBarData, setConversionBarData] = useState([
    { day: "Mon", conversions: 0 },
    { day: "Tue", conversions: 0 },
    { day: "Wed", conversions: 0 },
    { day: "Thurs", conversions: 0 },
    { day: "Fri", conversions: 0 },
    { day: "Sat", conversions: 0 },
    { day: "Sun", conversions: 0 },
  ]);

  const [conversionData, setConversionData] = useState(0);

  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]); // Default to today





  useEffect(() => {
    if (!user || !user.id || !user.role) {
      // setError("User information is missing. Please log in again.");
      setLoading(false);
      return;
    }
    fetchCallHistory(user, setCallData, setPieData, setAverageCallTime, setLoading, setError ,selectedDate);
    fetchQueueData(setQueueData, setLoading, setError);
    fetchPositiveCallData(setConversionBarData, setPositiveCallData, setLoading, setError,selectedDate);
  }, [user ,selectedDate]);


  useEffect(() => {
    const percentage = calculateConversionPercentage(callData);
    // console.log("Calculated conversion percentage:", percentage);
    setConversionData(percentage);
  }, [callData]);


  const handleDateChange = (e) => {
    setSelectedDate(e.target.value); // Update selected date
    setLoading(true); // Reset loading state
  };

  return (
    <div className=" bg-gray-100 p-5 font-sans overflow-y-auto" 
    style={{
      scrollbarWidth: "none", // Firefox
      msOverflowStyle: "none", // IE and Edge
    }}
    
    >
      <div className="flex justify-between items-center bg-gray-800 text-white p-3 rounded-md mb-5">
      <h2 className="text-xl font-semibold">Operations Manager Dashboard</h2>
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          className="bg-gray-700 text-white border-none rounded px-2 py-1 focus:outline-none"
        />
      </div>

      <div className="flex justify-between space-x-5">
        <div className="flex flex-col space-y-5 w-1/3">
        {/* {console.log("conversionData passed to ConversionGauge:", conversionData)}/ */}
        <ConversionGauge conversionData={conversionData } />
          <ConversionBarChart conversionBarData={conversionBarData} />
        </div>

        <div className="flex flex-col space-y-6 w-1/3">
          <CallStatisticsPie pieData={pieData} />
          <AverageCallTime averageCallTime={averageCallTime} />
        </div>

        <div className="flex flex-col space-y-5 w-1/3">
          <QueueList queueData={queueData} />
        </div>
      </div>

      {loading && <div className="text-center text-gray-700">Loading...</div>}
      {error && <div className="text-center text-red-500">{error}</div>}
    </div>
  );
};

export default Dashrigmo;


